// extracted by mini-css-extract-plugin
export default {"errorPlaceholder":"OrderAmountError_errorPlaceholder__Y4Buc"};